export enum ErrorType {
  RESIDENT_ALREADY_VERIFIED = 'RESIDENT_ALREADY_VERIFIED_L'
}
